import type { AdminCrewReportUploadModalHeaderProps } from "../../models/admin-crew-report.models";
import AdminCrewReportUploadVesselDetails from "./AdminCrewReportUploadVesselDetails";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const AdminCrewReportUploadModalHeader = ({
  preview,
  fileVesselImo,
  vesselDetailsStatus,
  vesselDetails,
  isSaving,
  titleRef,
  onCancel,
}: AdminCrewReportUploadModalHeaderProps) => (
  <header className="flex flex-none flex-col gap-3 border-b border-gray-200 px-5 py-3 dark:border-gray-700">
    <div className="flex min-w-0 items-start justify-between gap-4">
      <div className="min-w-0">
        <p className="text-[11px] font-semibold uppercase text-green">Crew Report Upload</p>
        <Dialog.Title
          as="h2"
          ref={titleRef}
          id="admin-crew-report-upload-modal-title"
          tabIndex={-1}
          className="mt-0.5 truncate text-lg font-semibold outline-none"
        >
          Verify Crew Report
        </Dialog.Title>
      </div>
      <button
        type="button"
        aria-label="Close crew report upload preview"
        title="Close"
        data-test="admin-crew-report-upload-modal-close"
        disabled={isSaving}
        className="flex h-7 w-7 flex-none items-center justify-center border border-gray-300 text-gray-500 hover:text-green disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700"
        onClick={onCancel}
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>

    <div
      className="flex min-w-0 flex-wrap gap-2 text-xs text-[#4A5655] dark:text-gray-300"
      data-test="admin-crew-report-upload-modal-subtitle"
    >
      <span className="inline-flex max-w-full items-center gap-1 border border-gray-200 bg-[#F8FBFA] px-2 py-1 dark:border-gray-700 dark:bg-gray-900">
        <span className="font-semibold uppercase text-[#637381] dark:text-gray-400">File</span>
        <span className="min-w-0 truncate font-medium">{preview.fileName}</span>
      </span>
      <span className="inline-flex items-center gap-1 border border-gray-200 bg-[#F8FBFA] px-2 py-1 dark:border-gray-700 dark:bg-gray-900">
        <span className="font-semibold uppercase text-[#637381] dark:text-gray-400">Sheet</span>
        <span className="font-medium">{preview.sheetName}</span>
      </span>
      <span className="inline-flex items-center gap-1 border border-gray-200 bg-[#F8FBFA] px-2 py-1 dark:border-gray-700 dark:bg-gray-900">
        <span className="font-semibold uppercase text-[#637381] dark:text-gray-400">Rows</span>
        <span className="font-medium">{preview.rows.length}</span>
      </span>
    </div>

    <AdminCrewReportUploadVesselDetails
      fileVesselImo={fileVesselImo}
      status={vesselDetailsStatus}
      vesselDetails={vesselDetails}
    />
  </header>
);

export default AdminCrewReportUploadModalHeader;
